import moment from "moment";

// Semaine par défaut : dimanche → samedi (demande métier).
// Format YYYY-MM-DD (local) pour flatpickr ; la conversion ISO/UTC est
// faite à la soumission (AddWeeklyReportPage.handleSubmit).
const today = moment();
const sundayStart = today.clone().subtract(today.day(), "days");
const saturdayEnd = sundayStart.clone().add(6, "days");

export default {
  type: "weekly-reports",
  starts_at: sundayStart.format("YYYY-MM-DD"),
  ends_at: saturdayEnd.format("YYYY-MM-DD"),
  report_uploaded_file: null,
  // counter_sales : null,
  // billing : null,
  // distributor_sales : null,
  // counter_purchase : null,
  // stationery : null,
  // cleaning_and_disposable_products : null,
  // others : null,
  // maintenance : null,
  // distributor : null,
  // wages : null,
  // rent : null,
  relationshipNames: [
    "organization",
    "establishment",
    "serviceCenter",
    "cafeteria",
  ],
  supplier: {
    type: "suppliers",
    id: null,
  },
  organization: {
    type: "organizations",
    id: null,
  },
  establishment: {
    type: "establishments",
    id: null,
  },
  serviceCenter: {
    type: "service-centers",
    id: null,
  },
  cafeteria: {
    type: "cafeterias",
    id: null,
  },
  allowedUsers: [],
  sales_vending_machines: 0,
  weekly_rent_discounts: [],
  // Add new field to store extra purchase order lines
  extra_purchase_lines: [],
  transfer_in_total: 0,
  transfer_out_total: 0,
  transfer_in_with_taxes: 0,
  transfer_out_with_taxes: 0,
};
